<template>
  <div
    id="modalOrcamento"
    v-if="visivel"
    style="display: block; padding-top: 200px" class="w3-modal"
    v-cloak>

    <div class="modal-container w3-modal-content">
      <header class="w3-container modal-wrapper">
        <span
          @click="fechar()"
          class="w3-button w3-display-topright">&times;</span>

        <h2 class="texto-vermelho titulo"> {{descricaoAutorizacao}}</h2>

        <div class="w3-col s12 m12 l12" v-if="processando">
          <div class="w3-panel w3-theme w3-card-2">
            <p>
              <i class="fa fa-sync-alt w3-spin"></i>
              <span> Processando...</span>
            </p>
          </div>
        </div>
      </header>

      <div v-if="!processando" class="w3-row-padding">
        <div class="w3-col s12 m12 l12">
          <strong>Código</strong>
          <input
            type="text"
            ref="campoUsuario"
            :disabled="modo == 'CER'"
            placeholder="Digite o código do usuário"
            v-model="usuario_id"
            class="w3-input w3-border">
        </div>

        <div class="w3-col s12 m12 l12">
          <strong>Senha</strong>
          <input
            type="password"
            ref="campoSenha"
            placeholder="Digite a senha"
            v-model="senha"
            v-on:keyup.enter="validarAutorizacao()"
            class="w3-input w3-border">
        </div>

        <div class="w3-col s6 m6 l6">
          <br>

          <button
            class="w3-button w3-block w3-theme"
            @click="validarAutorizacao()">
            <span>Ok</span>
          </button>
        </div>

        <div class="w3-col s6 m6 l6">
          <br>

          <button
            class="w3-button w3-block w3-gray w3-text-white"
            @click="fechar()">
            <span>Cancelar</span>
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import toastr from 'toastr';
  import RSessao from '@/components/Rest/RSessao';
  import Biblioteca from '@/components/Repositorio/Biblioteca';
  import store from '@/ambiente/store';

  export default {
    name: 'ModalAutorizar',

    props: {
      modo: {
        type: String,
        default: 'AUT',
        required: true
      },

      chave: {
        type: String,
        default: '',
        required: false
      },

      descricaoAutorizacao: {
        type: String,
        default: '',
        required: true
      }
    },

    data() {
      return {
        usuario_id: undefined,
        senha: '',
        visivel: false,
        processando: false
      }
    },

    methods: {
      async abrir() {
        if (!Biblioteca.em(this.modo, ['AUT', 'CER'])) {
          toastr.error(
            'O componente de autorização deve estar ' + 
            'configurado para autenticar ou certificar!'
          );
          return;
        }

        this.usuario_id = undefined;
        if (this.modo == 'CER') {
          this.usuario_id = await store.state.usuario_logado.funcionario_id;
        }

        if ((this.modo == 'CER') && (!this.usuario_id)) {
          toastr.error('Para certificar, é necessário determinar o código do usuário!');
          return;
        }

        this.visivel = true;

        this.senha = '';
        this.processando = false;

        if (this.usuario_id) {
          this.$nextTick(() =>this.$refs.campoSenha.focus());
        }
        else if (this.modo != 'CER') {
          this.$nextTick(() =>this.$refs.campoUsuario.focus());
        }
      },

      fechar() {
        this.usuario_id = 0;
        this.senha = '';
        this.visivel = false;
        this.processando = false;

        this.$emit('close');
      },

      async validarAutorizacao() {
        try {
          if (!this.usuario_id) {
            toastr.error('Informe o código do usuário!');
            return;
          }

          if (!this.senha) {
            toastr.error('Informe a senha!');
            return;
          }

          this.processando = true;

          let parametros = {
            usuario_id: this.usuario_id,
            senha: this.senha,
            chave: this.chave
          }

          let retorno = await RSessao.autorizar(this.axios, parametros);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.$emit('confirmarAutorizacao', this.usuario_id);
          this.fechar();
        }
        catch (error) {
          toastr.error('Usuário não autorizado a ' + this.descricaoAutorizacao.toLowerCase + '!');
          this.fechar();
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Autorizar.vue